import React, { useState, useEffect } from 'react';

const PhoneInput = (props: any) => {
    const [id] = useState(Math.random().toString().split(".")[1]);
    const [code, setCode] = useState(props.defaultCode || "+976");
    const [number, setNumber] = useState("");

    useEffect(() => {
        if (props.state) {
            setCode(((props.state || "").match(/\+(976|82)/) || [])[0] || "+976");
            setNumber(((props.state || "").match(/\+(976|82)([0-9]+)/) || [])[2] || "");
        }
    }, [props.state])

    useEffect(() => {
        if (code && number) {
            props.setState(code + number)
        }
    }, [props, code, number])

    return (
        <div className="form-group">
            {props.label &&
                <label htmlFor={id}>{props.label}:</label>
            }
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <button className="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">{code}</button>
                    <div className="dropdown-menu">
                        <div role="button" className="dropdown-item" onClick={() => setCode("+976")}>
                            <span className="badge badge-secondary">+976</span> Монгол
                        </div>
                        <div role="button" className="dropdown-item" onClick={() => setCode("+82")}>
                            <span className="badge badge-secondary">+82</span> Солонгос
                        </div>
                    </div>
                </div>
                <input type="number" className="form-control" id={id} defaultValue={number} onChange={(e) => setNumber(e.target.value)} />
                {props.append && (
                    <div className="input-group-append">
                        {typeof props.append === "string" ?
                            <div className="input-group-text">{typeof props.append}</div>
                        :
                            <>{props.append}</>
                        }
                    </div>
                )}
            </div>
        </div>
    );
}

export default PhoneInput;